
























































import {Component, Emit} from "vue-property-decorator";
import abpbase from "../../lib/abpbase";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import {recordElement} from "@/api/typeDefined";
import WordCloudChart from "@/components/wordCloudChart.vue";
import SectionLayout from "@/layouts/sectionLayout.vue";
import {EMPTY_OBJECT} from "@/lib/appconst";

@Component({
  name: 'globalList',
  components: {SectionLayout, WordCloudChart}
})
export default class globalList extends abpbase {
  //所有数据
  allRecords: recordElement[] = [];

  //词云所需数据
  wordCloudData: any[] = [];

  // 是否显示完整标题(true:不显示)
  isShowTitle: boolean = true;

  get getWordCloudData() {
    return this.wordCloudData;
  }


  //获取热门关键字
  fetchHotKeyWords() {
    ajaxHelperInstance.get('/web/record/getHot', {}, undefined, this).then((res) => {
      let {status, data} = res;
      if (status === 200) {
        let hotKeyWords = data.data || [];
        //生成词云数据
        this.wordCloudData = hotKeyWords.map(item => {
          return {
            name: item.text,
            value: item.weight
          };
        });
      }
    });
  }

  //获取所有的记录
  fetchRecords() {
    ajaxHelperInstance.get('/web/global/index', {}, undefined, this).then((res) => {
      let {status, data} = res;
      if (status === 200) {
        this.allRecords = data.data || [];
        console.log(this.allRecords);
      }
    });
  }

  //显示详情
  handleShowDetail(item: any) {
    let {moduleType} = item;
    let routerName = '';
    let queryParams: object = EMPTY_OBJECT;

    //知识库
    if (moduleType == 1) {
      routerName = 'knowledgeBaseDetail';
      let {docId} = item;
      queryParams = {
        queryParams: JSON.stringify({
          docId: docId,
          keywords: ''
        })
      };
    } else if (moduleType == 2) {//Q&QA
      routerName = 'QADetail';
      let {questionId} = item;
      queryParams = {
        queryParams: JSON.stringify({
          questionId: questionId
        })
      };
    }
    if (routerName) {
      this.switchRouting(routerName, queryParams);
    }
  }

  //点击词云
  handleClickWordCloud(params: any) {
    let {name} = params;
    //跳到搜索页
    this.switchRouting('query', {keywords: name});
  }

  //初始化
  init() {
    this.fetchHotKeyWords();
    this.fetchRecords();
  }

  created() {
    this.init();
  }
}
